module.exports = __webpack_public_path__ + "static/media/marker-ocurrency.f1e541f4.png";